import React from 'react'
import { Button } from 'antd'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import SubscriptionDetails, { PlanSummary } from './SubscriptionDetails'
import { FOOD_SAFETY_SURFACE } from 'src/constants/foodSafety'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import useIsBlocked from 'src/hooks/useIsBlocked'
import PermissionBlockScreen from 'src/components/shared/PermissionBlockScreen'
import GrowthEngineHumanDemoRow from 'src/components/growthEngine/GrowthEngineHumanDemoRow'
import {
  PLAN_COMPARISON_LIST,
  planDisplayName,
} from 'src/constants/planDisplay'

const Subscriptions = () => {
  const blocked = useIsBlocked('subscriptions')

  if (blocked) {
    return <PermissionBlockScreen />
  }

  const venue = useSelector(state => state.venue.venue)
  const history = useHistory()
  const subscriptions = { ...venue.subscriptions, ...venue.newPricing }
  let components = []

  const getSubscribedComponents = () => {
    components = []

    Object.keys(subscriptions || {}).forEach(subscriptionKey => {
      const subscription = subscriptions[subscriptionKey]
      if (subscription && !subscription.isSubscribed === false) {
        components.push(
          <SubscriptionDetails
            key={subscriptionKey}
            subscriptionData={subscription}
            subscriptionKey={subscriptionKey}
          />,
        )
      }
    })

    return components.length > 0 ? components : null
  }

  const paidPlans = getSubscribedComponents()
  const onLitePlan = !paidPlans

  return (
    <Page>
      {paidPlans || (
        <PlanSummary title={planDisplayName('Free')} status='active' />
      )}
      <NextCard>
        <NextTitle>Compare plans</NextTitle>
        <NextBody>
          {onLitePlan
            ? `You're on ${planDisplayName(
                'Free',
              )} (£0/month). Move up whenever you want — ${PLAN_COMPARISON_LIST} are listed side by side.`
            : `Move up or down whenever you want. ${PLAN_COMPARISON_LIST} are listed side by side.`}
        </NextBody>
        <Button
          type='primary'
          data-testid='subscriptions-upgrade-options'
          onClick={() =>
            history.push(`/v/${venue._id}/subscriptions/oms-plans`)
          }
        >
          See plans
        </Button>
        <HelpBlock>
          <GrowthEngineHumanDemoRow compact />
        </HelpBlock>
      </NextCard>
    </Page>
  )
}

export default Subscriptions

const Page = styled.div`
  max-width: 52rem;
  padding: 0.25rem 0.25rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

const NextCard = styled.section`
  padding: 1rem 1.1rem 0.85rem;
  border: 1px solid ${FOOD_SAFETY_SURFACE.HERO_BORDER};
  border-radius: ${FOOD_SAFETY_SURFACE.CARD_RADIUS};
  background: #fff;
  box-shadow: ${FOOD_SAFETY_SURFACE.CARD_SHADOW};
`

const NextTitle = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  line-height: 1.3;
  font-weight: 700;
  color: ${({ theme }) => theme.colours.bbqBlack || '#000'};
`

const NextBody = styled.p`
  margin: 0.25rem 0 0.75rem;
  max-width: 36rem;
  font-size: 0.9rem;
  line-height: 1.4;
  color: #555555;
`

const HelpBlock = styled.div`
  margin-top: 0.9rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${FOOD_SAFETY_SURFACE.HERO_BORDER};
`
